import {
  Autocomplete,
  Button,
  CircularProgress,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../Redux/AlertReducer";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";

export const FormEditFaq = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.Faqs.Edit + id,
        data: formDataToSend,
        isFormData: true,
      });

      setIsLoadingSubmit(false);
      if (response) {
        dispatch(setSuccess(true));
        navigate("/Faqs");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
      setIsLoadingSubmit(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label={data.title != "" ? "" : "Title"}
          name="title"
          required
          type="title"
          autoComplete="off"
          value={data.title}
          onChange={handleInputChange}
          variant="outlined"
        />
        <TextField
          fullWidth
          margin="normal"
          label={data.description != "" ? "" : "Description"}
          name="description"
          required
          type="description"
          autoComplete="off"
          value={data.description}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>

      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
